import { AppTheme } from './theme'
import { useTheme } from '@emotion/react'

export function useAppTheme(): AppTheme {
  return useTheme() as AppTheme
}
